/**
 * Process activity types and interfaces
 */

export interface ActivityData {
  _id: string;
  avatar: string;
  title: string;
  name: string;
  product: string;
  activities: string;
  time: string;
  status?: ActivityStatus;
  priority?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum ActivityStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  DELAYED = "DELAYED"
}

export const ActivityStatusLabels: Record<ActivityStatus, string> = {
  [ActivityStatus.PENDING]: "Pendente",
  [ActivityStatus.IN_PROGRESS]: "Em andamento",
  [ActivityStatus.COMPLETED]: "Concluído",
  [ActivityStatus.DELAYED]: "Atrasada"
};

export interface ActivityFilterParams {
  product?: string;
  search?: string;
  startDate?: string;
  endDate?: string;
  status?: ActivityStatus;
  priority?: boolean;
  page?: number;
  limit?: number;
}

export interface FilledForm {
  _id: string;
  phaseFormName: string;
  formFields: Array<{
    _id: string;
    name: string;
    type: string;
    text: string;
    description: string;
    required: boolean;
  }>;
}

export interface ActivityOutputDTO {
  _id: string;
  avatar: string;
  title: string;
  name: string;
  product: string;
  activities: string;
  time: string;
  status: ActivityStatus;
  priority: boolean;
  createdAt: Date;
  updatedAt: Date;
  filledForms?: FilledForm[];
} 